/**
 * Custom Element: MCartDrawerProgress
 */
class MCartDrawerProgress extends HTMLElement {
    // Array to hold cleanup functions for event subscriptions to prevent memory leaks
    _$Subscriptions = [];

    /**
     * Component constructor initializing basic properties and DOM references.
     */
    constructor() {
        // Initialize the parent HTMLElement class
        super();
    }

    /**
     * Initializes the component's event listeners and subscriptions.
     */
    initializeListners() {
        // Update the list whenever the cart content changes globally
        const cartUpdate$ = window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, async (e) => {
            // Trigger a re-render to reflect current cart state
            this.renderProgress(e);
        });

        // Track the cart update subscription for later removal
        this._$Subscriptions.push(cartUpdate$);
    }

    async renderProgress(e) {
        const wrapper = this.querySelector('.progress');
        const bar = this.querySelector('.progress-bar');
        const msg = this.querySelector('#shipping-goal-message');
        const cartAlert = document.querySelector('#cart-alert');

        if (!wrapper || !bar || !msg) return;

        let cart = e;
        if (typeof cart.total_price === 'undefined') {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`);
            cart = await response.json();
        }

        const threshold = parseFloat(wrapper.getAttribute('data-threshold')) || 10000;
        const total = parseFloat(cart.total_price);

        // 2. Calculate
        const percentage = Math.min((total / threshold) * 100, 100);
        const finalPercentage = Math.round(percentage);

        // 3. Update UI
        bar.style.width = `${finalPercentage}%`;
        bar.setAttribute('aria-valuenow', finalPercentage);

        // 4. Update Text Message
        if (total < threshold) {
            const remaining = threshold - total;
            const currencyCode = cart.currency || 'USD';
            const formattedRemaining = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
            }).format(remaining / 100);

            cartAlert.style.display = 'none';
            msg.innerHTML = `Add <strong>${formattedRemaining}</strong> to your cart to unlock free shipping!`;
        } else {
            cartAlert.style.display = 'block';
            msg.innerHTML = `🎉 You've unlocked <strong>FREE SHIPPING!</strong>`;
        }
    }

    /**
     * Called when the element is inserted into the DOM.
     */
    connectedCallback() {
        // Start the event listeners when the element becomes active in the browser
        this.initializeListners();
    }

    /**
     * Called when the element is removed from the DOM.
     */
    disconnectedCallback() {
        // Loop through all active subscriptions to clean them up
        this._$Subscriptions.forEach((sub) => {
            // Handle cleanup if the subscription has an unsubscribe method
            if (sub && typeof sub.unsubscribe === 'function') sub.unsubscribe();
            // Handle cleanup if the subscription itself is a direct function
            if (typeof sub === 'function') sub();
        });
    }
}

// Check if the custom element is already registered to avoid naming conflicts
if (!customElements.get('m-cart-drawer-progress')) {
    // Register the class as a usable HTML tag in the DOM
    customElements.define('m-cart-drawer-progress', MCartDrawerProgress);
}
